import type { MessageType } from '@/types/Chat'
import type { Component } from 'vue'

// message types
import TextMessage from '@/components/messageTypes/TextMessage.vue'
import ChangeAmbulance from '@/components/messageTypes/ChangeAmbulance.vue'
import ChangeAssignedStaff from '@/components/messageTypes/ChangeAssignedStaff.vue'
import ChannelCreated from '@/components/messageTypes/ChannelCreated.vue'
import Deleted from '@/components/messageTypes/Deleted.vue'
import SessionClosed from '@/components/messageTypes/SessionClosed.vue'
import MedicalRecordMerge from '@/components/messageTypes/MedicalRecordMerge.vue'
import UnknownMessageType from '@/components/messageTypes/Unknown.vue'

const messageComponentMap: Record<MessageType, Component> = {
	TextMessage: TextMessage,
	Attachment: TextMessage,
	ChangeAmbulance: ChangeAmbulance,
	ChangeAssignedStaff: ChangeAssignedStaff,
	ChannelCreated: ChannelCreated,
	Deleted: Deleted,
	SessionClosed: SessionClosed,
	MedicalRecordMerge: MedicalRecordMerge
}

export const getMessageType = (type: MessageType): Component => {
	return messageComponentMap[type] || UnknownMessageType
}
